import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cloud-application-development',
  templateUrl: './cloud-application-development.component.html',
  styleUrls: ['./cloud-application-development.component.sass']
})
export class CloudApplicationDevelopmentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
